import React, { useEffect, useState, useRef, useContext } from "react";
import { useSelector } from "react-redux";
import NumberInput from "../../framework/NumberInput";
import TextInput from "../../framework/TextInput";
import classes from "./AccountConfigPanel.module.css";
import { stateCodes } from "../../utils/constant";
import SelectInput from "../../framework/SelectInput";
import DateInput from "../../framework/date/DateInput";
import moment from "moment";
import Checkbox from "../../framework/Checkbox";
import GlobalContext from "../../framework/GlobalContext";
import { executeScroll } from "../../utils/utils";
import { Grid } from "@mui/material";
import ConfigurationContext from "./ConfigurationContext";

const AccountConfigPanel = (props) => {
  const {
    SHOP_NAME,
    MOBILE_NUMBER,
    WHATSAPP_NUMBER,
    TELEPHONE_NUMBER,
    SHOP_ADDRESS,
    GST_STATE_CODE,
    SHOP_CITY,
    SHOP_PINCODE,
    SHOP_GST_NUMBER,
    SHOP_DRUG_LICENSE_NUMBER,
    INVOICE_PREFIX,
    RETAILER_SHORT_NAME,
    RETAILER_CODE,
    SAME_NUMBER_FOR_WHATSAPP,
    EMAIL_ID,
    PASSWORD,
    SHOP_SHORT_ADDRESS,
    SHOP_FSSAI_NUMBER,
    SHOP_CIN_NUMBER,
    START_FIN_DATE,
    END_FIN_DATE,
    LICENSE_EXPIRY,
  } = useSelector(
    (state) =>
      state.commonReducer.tabs[state.commonReducer.activeTabIndex].configData
  );
  const { formLabels } = useContext(ConfigurationContext);
  const { focusField } = useContext(GlobalContext);
  const [stateCode, setStateCode] = useState({ label: GST_STATE_CODE });
  const [shopName, setShopName] = useState(SHOP_NAME);
  const [retailerCode, setRetailerCode] = useState(RETAILER_CODE);
  const [mobileNumber, setMobileNumber] = useState(MOBILE_NUMBER);
  const [whatsappNumber, setWhatsappNumber] = useState(WHATSAPP_NUMBER || "");
  const [sameNumberForWhatsapp, setSameNumberForWhatsapp] = useState(
    SAME_NUMBER_FOR_WHATSAPP
  );
  const [telephoneNumber, setTelephoneNumber] = useState(TELEPHONE_NUMBER);
  const [shopAddress, setShopAddress] = useState(SHOP_ADDRESS);
  const [shopCity, setShopCity] = useState(SHOP_CITY);
  const [shopPincode, setShopPincode] = useState(SHOP_PINCODE);
  const [shopGstNumber, setShopGstNumber] = useState(SHOP_GST_NUMBER);
  const [shopCinNumber, setShopCinNumber] = useState(SHOP_CIN_NUMBER);
  const [shopFssaiNumber, setShopFssaiNumber] = useState(SHOP_FSSAI_NUMBER);
  const [shopShortAddress, setShopShortAddress] = useState(SHOP_SHORT_ADDRESS);
  const [shopDrugLicenseNumber, setShopDrugLicenseNumber] = useState(
    SHOP_DRUG_LICENSE_NUMBER
  );
  const [invoicePrefix, setInvoicePrefix] = useState(INVOICE_PREFIX);
  const [retailerShortName, setRetailerShortName] =
    useState(RETAILER_SHORT_NAME);
  const [emailId, setEmailId] = useState(EMAIL_ID);
  const [password, setPassword] = useState(PASSWORD);
  const [finStartDate, setFinStartDate] = useState(
    moment(START_FIN_DATE).format("DD/MM/YYYY")
  );
  const [finEndDate, setFinEndDate] = useState(
    moment(END_FIN_DATE).format("DD/MM/YYYY")
  );
    const [licenseExpiryDate, setLicenseExpiryDate] = useState(moment(LICENSE_EXPIRY).format("DD/MM/YYYY"));

  const configAccountsShopNameRef = useRef();
  const retailerCodeRef = useRef();
  const mobileNumberRef = useRef();
  const accountUseForWhatsappRef = useRef();
  const whatsappNumberRef = useRef();
  const telephoneNumberRef = useRef();
  const shopAddressRef = useRef();
  const gstStateCodeRef = useRef();
  const shopCityRef = useRef();
  const pincodeRef = useRef();
  const shopShortAddressRef = useRef();
  const gstNumberRef = useRef();
  const drugLicenseRef = useRef();
  const cin_numberRef = useRef();
  const fssai_numberRef = useRef();
  const invoicePrefixRef = useRef();
  const shortNameRef = useRef();
  const finStartDateRef = useRef();
  const finEndDateRef = useRef();
  const emailDetailsRef = useRef();
  const passwordRef = useRef();
  const licenseExpiryDateRef=useRef();

  const withPhoneCap = ({ value }) => value.length <= 10;
  // const [retailerCode] = useState(RETAILER_CODE);

  const onCheckWhatsApp = (value) => {
    if (value) {
      setWhatsappNumber(MOBILE_NUMBER);
      props.handleFormChange("SAME_NUMBER_FOR_WHATSAPP", value, "ACCOUNTS");
      props.handleFormChange("WHATSAPP_NUMBER", mobileNumber, "ACCOUNTS");
    }
    if (!value && whatsappNumber.toString().length) {
      props.handleFormChange("SAME_NUMBER_FOR_WHATSAPP", value, "ACCOUNTS");
      setWhatsappNumber("");
      props.handleFormChange("WHATSAPP_NUMBER", "", "ACCOUNTS");
    }
  };

  useEffect(() => {
    focusField("sar_filter_start_date");
    configAccountsShopNameRef?.current.focus({ preventScroll: true });
  }, [focusField]);

  return (
    <Grid container columnGap={2} rowGap={2} columns={12}>
      <Grid item xs={12}>
        <div className={classes["accountconfigpanel-text-style"]}>Account</div>
      </Grid>
      <Grid item xs={2}>
        <TextInput
          id="config_accounts_retailer_code"
          name="retailerCode"
          ref={retailerCodeRef}
          label={formLabels?.RETAILER_CODE?.displayName}
          value={retailerCode}
          onFocus={() => {
            executeScroll(retailerCodeRef);
            focusField("config_accounts_retailer_code");
          }}
          onChange={(e) => {
            setRetailerCode(e.target.value);
            props.handleFormChange("RETAILER_CODE", e.target.value, "ACCOUNTS");
          }}
          InputProps={{
            readOnly: true,
          }}
        />
      </Grid>
      <Grid item xs={12}>
        <div className={classes["accountconfigpanel-text-style"]}>
          Shop Details
        </div>
      </Grid>
      <Grid item xs={3}>
        <TextInput
          id="config_accounts_shop_name"
          name="shopName"
          ref={configAccountsShopNameRef}
          label={formLabels?.SHOP_NAME?.displayName}
          value={shopName}
          onFocus={() => {
            executeScroll(configAccountsShopNameRef);
            focusField("config_accounts_shop_name");
          }}
          onChange={(e) => {
            setShopName(e.target.value);
            props.handleFormChange("SHOP_NAME", e.target.value, "ACCOUNTS");
          }}
          inputProps={{
            "data-markers": JSON.stringify({
              up: "config_accounts_shop_name",
              down: "config_accounts_shop_address",
              left: "config_accounts_shop_name",
              right: "config_accounts_mobile_number",
            }),
          }}
        />
      </Grid>
      <Grid item xs={2}>
        <NumberInput
          id="config_accounts_mobile_number"
          name="mobileNumber"
          ref={mobileNumberRef}
          label={formLabels?.MOBILE_NUMBER?.displayName}
          value={mobileNumber || ""}
          decimalScale={0}
          allowNegative={false}
          onFocus={() => {
            executeScroll(mobileNumberRef);
            focusField("config_accounts_mobile_number");
          }}
          isAllowed={withPhoneCap}
          onBlur={(e) => {
            setMobileNumber(e.target.value);
            props.handleFormChange("MOBILE_NUMBER", e.target.value, "ACCOUNTS");
          }}
          inputProps={{
            "data-markers": JSON.stringify({
              up: "config_accounts_mobile_number",
              down: "config_accounts_shop_address",
              left: "config_accounts_shop_name",
              right: "config_accounts_use_for_whatsapp",
            }),
          }}
        />
      </Grid>

      <Grid item xs={2}>
        <Checkbox
          id="config_accounts_use_for_whatsapp"
          name="accountUseForWhatsapp"
          ref={accountUseForWhatsappRef}
          label={formLabels?.SAME_NUMBER_FOR_WHATSAPP?.displayName}
          checked={sameNumberForWhatsapp}
          onFocus={() => {
            executeScroll(accountUseForWhatsappRef);
            focusField("config_accounts_use_for_whatsapp");
          }}
          onChange={(e) => {
            setSameNumberForWhatsapp(e.target.checked);
            onCheckWhatsApp(e.target.checked);
            props.handleFormChange(
              "SAME_NUMBER_FOR_WHATSAPP",
              e.target.checked,
              "ACCOUNT"
            );
          }}
          inputProps={{
            "data-markers": JSON.stringify({
              up: "config_accounts_use_for_whatsapp",
              down: "config_accounts_shop_address",
              left: "config_accounts_mobile_number",
              right: !sameNumberForWhatsapp
                ? "config_accounts_whatsapp_number"
                : "config_accounts_telephone_number",
            }),
          }}
        />
      </Grid>
      <Grid item xs={2}>
        <NumberInput
          id="config_accounts_whatsapp_number"
          name="whatsappNumber"
          ref={whatsappNumberRef}
          label={formLabels?.WHATSAPP_NUMBER?.displayName}
          value={whatsappNumber}
          disabled={sameNumberForWhatsapp}
          decimalScale={0}
          allowNegative={false}
          isAllowed={withPhoneCap}
          onFocus={() => {
            executeScroll(whatsappNumberRef);
            focusField("config_accounts_whatsapp_number");
          }}
          onBlur={(e) => {
            setWhatsappNumber(e.target.value);
            props.handleFormChange(
              "WHATSAPP_NUMBER",
              e.target.value,
              "ACCOUNTS"
            );
          }}
          inputProps={{
            "data-markers": JSON.stringify({
              up: "config_accounts_whatsapp_number",
              down: "config_accounts_shop_address",
              left: "config_accounts_use_for_whatsapp",
              right: "config_accounts_telephone_number",
            }),
          }}
        />
      </Grid>
      <Grid item xs={2}>
        <TextInput
          id="config_accounts_telephone_number"
          name="telephoneNumber"
          ref={telephoneNumberRef}
          label={formLabels?.TELEPHONE_NUMBER?.displayName}
          value={telephoneNumber}
          onFocus={() => {
            executeScroll(telephoneNumberRef);
            focusField("config_accounts_telephone_number");
          }}
          onChange={(e) => {
            setTelephoneNumber(e.target.value);
            props.handleFormChange(
              "TELEPHONE_NUMBER",
              e.target.value,
              "ACCOUNTS"
            );
          }}
          inputProps={{
            "data-markers": JSON.stringify({
              up: "config_accounts_telephone_number",
              down: "config_accounts_shop_address",
              left: !sameNumberForWhatsapp
                ? "config_accounts_whatsapp_number"
                : "config_accounts_use_for_whatsapp",
              right: "config_accounts_shop_address",
            }),
          }}
        />
      </Grid>
      <Grid container columns={12}>
        <TextInput
          id="config_accounts_shop_address"
          name="shopAddress"
          ref={shopAddressRef}
          label={formLabels?.SHOP_ADDRESS?.displayName}
          value={shopAddress}
          onFocus={() => {
            executeScroll(shopAddressRef);
            focusField("config_accounts_shop_address");
          }}
          onChange={(e) => {
            setShopAddress(e.target.value);
          }}
          onBlur={(e) => {
            props.handleFormChange("SHOP_ADDRESS", e.target.value, "ACCOUNTS");
          }}
          inputProps={{
            "data-markers": JSON.stringify({
              up: "config_accounts_shop_name",
              down: "config_accounts_gst_state_code",
              left: "config_accounts_telephone_number",
              right: "config_accounts_gst_state_code",
            }),
          }}
        />
      </Grid>
      <Grid item xs={3}>
        <SelectInput
          id="config_accounts_gst_state_code"
          label={formLabels?.GST_STATE_CODE?.displayName}
          name="gstStateCode"
          ref={gstStateCodeRef}
          onFocus={() => {
            executeScroll(gstStateCodeRef);
            focusField("config_accounts_gst_state_code");
          }}
          onChange={(event, value) => {
            setStateCode({ label: value.id });
            props.handleFormChange("GST_STATE_CODE", value.id, "ACCOUNTS");
          }}
          getOptionLabel={(option) => option.label}
          isOptionEqualToValue={(option, value) => {
            return value.label === option.label;
          }}
          options={stateCodes}
          markers={JSON.stringify({
            up: "config_accounts_shop_address",
            down: "config_accounts_gst_num",
            left: "config_accounts_shop_address",
            right: "config_accounts_shop_city",
          })}
          value={stateCodes.find((opn) => opn.id === stateCode?.label)}
        />
      </Grid>
      <Grid item xs={3}>
        <TextInput
          id="config_accounts_shop_city"
          name="shopCity"
          ref={shopCityRef}
          label={formLabels?.SHOP_CITY?.displayName}
          value={shopCity}
          onFocus={() => {
            executeScroll(shopCityRef);
            focusField("config_accounts_shop_city");
          }}
          onChange={(e) => {
            setShopCity(e.target.value);
            props.handleFormChange("SHOP_CITY", e.target.value, "ACCOUNTS");
          }}
          inputProps={{
            "data-markers": JSON.stringify({
              up: "config_accounts_shop_address",
              down: "config_accounts_drug_license",
              left: "config_accounts_gst_state_code",
              right: "config_accounts_pin_code",
            }),
          }}
        />
      </Grid>
      <Grid item xs={2}>
        <NumberInput
          id="config_accounts_pin_code"
          name="pincode"
          ref={pincodeRef}
          label={formLabels?.SHOP_PINCODE?.displayName}
          value={shopPincode}
          onFocus={() => {
            executeScroll(pincodeRef);
            focusField("config_accounts_pin_code");
          }}
          onValueChange={(values, e) => {
            setShopPincode(values.floatValue);
            props.handleFormChange(
              "SHOP_PINCODE",
              values.floatValue,
              "ACCOUNTS"
            );
          }}
          inputProps={{
            "data-markers": JSON.stringify({
              up: "config_accounts_shop_address",
              down: "config_accounts_cin_num",
              left: "config_accounts_shop_city",
              right: "config_accounts_shop_short_address",
            }),
          }}
        />
      </Grid>
      <Grid item xs={3}>
        <TextInput
          id="config_accounts_shop_short_address"
          name="shopShortAddress"
          ref={shopShortAddressRef}
          label={formLabels?.SHOP_SHORT_ADDRESS?.displayName}
          value={shopShortAddress}
          onFocus={() => {
            executeScroll(shopShortAddressRef);
            focusField("config_accounts_shop_short_address");
          }}
          onChange={(e) => {
            setShopShortAddress(e.target.value);
            props.handleFormChange(
              "SHOP_SHORT_ADDRESS",
              e.target.value,
              "ACCOUNTS"
            );
          }}
          inputProps={{
            "data-markers": JSON.stringify({
              up: "config_accounts_shop_address",
              down: "config_accounts_fssai_num",
              left: "config_accounts_pin_code",
              right: "config_accounts_gst_num",
            }),
          }}
        />
      </Grid>

      <Grid item xs={12}>
        <div className={classes["accountconfigpanel-text-style"]}>
          License Details
        </div>
      </Grid>

      <Grid item xs={3}>
        <TextInput
          id="config_accounts_gst_num"
          name="gstNumber"
          ref={gstNumberRef}
          label={formLabels?.SHOP_GST_NUMBER?.displayName}
          value={shopGstNumber}
          onFocus={() => {
            executeScroll(gstNumberRef);
            focusField("config_accounts_gst_num");
          }}
          onChange={(e) => {
            setShopGstNumber(e.target.value.toUpperCase());
          }}
          onBlur={(e) => {
            props.handleFormChange(
              "SHOP_GST_NUMBER",
              e.target.value.toUpperCase(),
              "ACCOUNTS"
            );
          }}
          inputProps={{
            "data-markers": JSON.stringify({
              up: "config_accounts_gst_state_code",
              down: "config_accounts_license_expiry",
              left: "config_accounts_shop_short_address",
              right: "config_accounts_drug_license",
            }),
          }}
        />
      </Grid>
      <Grid item xs={3}>
        <TextInput
          id="config_accounts_drug_license"
          name="drugLicense"
          ref={drugLicenseRef}
          label={formLabels?.SHOP_DRUG_LICENSE_NUMBER?.displayName}
          value={shopDrugLicenseNumber}
          onFocus={() => {
            executeScroll(drugLicenseRef);
            focusField("config_accounts_drug_license");
          }}
          onChange={(e) => {
            setShopDrugLicenseNumber(e.target.value);
            props.handleFormChange(
              "SHOP_DRUG_LICENSE_NUMBER",
              e.target.value.toUpperCase(),
              "ACCOUNTS"
            );
          }}
          inputProps={{
            "data-markers": JSON.stringify({
              up: "config_accounts_shop_city",
              down: "config_accounts_retailer_short_name",
              left: "config_accounts_gst_num",
              right: "config_accounts_cin_num",
            }),
          }}
        />
      </Grid>
      <Grid item xs={3}>
        <TextInput
          id="config_accounts_cin_num"
          name="cin_number"
          ref={cin_numberRef}
          label={formLabels?.SHOP_CIN_NUMBER?.displayName}
          value={shopCinNumber}
          onChange={(e) => {
            setShopCinNumber(e.target.value.toUpperCase());
          }}
          onFocus={() => {
            executeScroll(cin_numberRef);
            focusField("config_accounts_cin_num");
          }}
          onBlur={(e) => {
            props.handleFormChange(
              "SHOP_CIN_NUMBER",
              e.target.value.toUpperCase(),
              "ACCOUNTS"
            );
          }}
          inputProps={{
            "data-markers": JSON.stringify({
              up: "config_accounts_pin_code",
              down: "config_accounts_fin_start_date",
              left: "config_accounts_drug_license",
              right: "config_accounts_fssai_num",
            }),
          }}
        />
      </Grid>
      <Grid item xs={2}>
        <TextInput
          id="config_accounts_fssai_num"
          name="fssai_number"
          ref={fssai_numberRef}
          label={formLabels?.SHOP_FSSAI_NUMBER?.displayName}
          value={shopFssaiNumber}
          onFocus={() => {
            executeScroll(fssai_numberRef);
            focusField("config_accounts_fssai_num");
          }}
          onChange={(e) => {
            setShopFssaiNumber(e.target.value.toUpperCase());
          }}
          onBlur={(e) => {
            props.handleFormChange(
              "SHOP_FSSAI_NUMBER",
              e.target.value.toUpperCase(),
              "ACCOUNTS"
            );
          }}
          inputProps={{
            "data-markers": JSON.stringify({
              up: "config_accounts_shop_short_address",
              down: "config_accounts_fin_end_date",
              left: "config_accounts_cin_num",
              right: "config_accounts_license_expiry",
            }),
          }}
        />
      </Grid>
      <Grid item xs={2}>
      <DateInput id="config_accounts_license_expiry"
          label={formLabels?.LICENSE_EXPIRY?.displayName}
          ref={licenseExpiryDateRef}
          placeholder="DD/MM/YYYY"
          onChange={(e, value) => {
            setLicenseExpiryDate(value);
          }}
          onBlur={(e,value) => {
            props.handleFormChange("LICENSE_EXPIRY", value, "ACCOUNTS");
          }}
          onFocus={() => {
            executeScroll(licenseExpiryDateRef);
            focusField("config_accounts_license_expiry");
          }}
          value={licenseExpiryDate}
          allowFuture={true}
          inputProps={{
            "data-markers": JSON.stringify({
              up: "config_accounts_gst_num",
              down: "config_accounts_invoice_prefix",
              left: "config_accounts_fssai_num",
              right: "config_accounts_invoice_prefix",
            }),
          }}/>
      </Grid>
      <Grid item xs={12}>
        <div className={classes["accountconfigpanel-text-style"]}>
          Other Details
        </div>
      </Grid>
      <Grid item xs={3}>
        <TextInput
          id="config_accounts_invoice_prefix"
          name="invoicePrefix"
          ref={invoicePrefixRef}
          label={formLabels?.INVOICE_PREFIX?.displayName}
          value={invoicePrefix}
          onFocus={() => {
            executeScroll(invoicePrefixRef);
            focusField("config_accounts_invoice_prefix");
          }}
          onChange={(e) => {
            setInvoicePrefix(e.target.value);
            props.handleFormChange(
              "INVOICE_PREFIX",
              e.target.value,
              "ACCOUNTS"
            );
          }}
          inputProps={{
            "data-markers": JSON.stringify({
              up: "config_accounts_license_expiry",
              down: "config_accounts_email_details",
              left: "config_accounts_license_expiry",
              right: "config_accounts_retailer_short_name",
            }),
          }}
        />
      </Grid>
      <Grid item xs={2}>
        <TextInput
          id="config_accounts_retailer_short_name"
          name="shortName"
          ref={shortNameRef}
          label={formLabels?.RETAILER_SHORT_NAME?.displayName}
          value={retailerShortName}
          onFocus={() => {
            executeScroll(shortNameRef);
            focusField("config_accounts_retailer_short_name");
          }}
          onChange={(e) => {
            setRetailerShortName(e.target.value);
            props.handleFormChange(
              "RETAILER_SHORT_NAME",
              e.target.value,
              "ACCOUNTS"
            );
          }}
          inputProps={{
            "data-markers": JSON.stringify({
              up: "config_accounts_drug_license",
              down: "config_accounts_password",
              left: "config_accounts_invoice_prefix",
              right: "config_accounts_fin_start_date",
            }),
          }}
        />
      </Grid>
      <Grid item xs={2}>
        <DateInput
          id="config_accounts_fin_start_date"
          label={formLabels?.START_FIN_DATE?.displayName}
          ref={finStartDateRef}
          placeholder="DD/MM/YYYY"
          onChange={(e, value) => {
            setFinStartDate(value);
          }}
          onBlur={(e) => {
            props.handleFormChange("START_FIN_DATE", finStartDate, "ACCOUNTS");
          }}
          onFocus={() => {
            executeScroll(finStartDateRef);
            focusField("config_accounts_fin_start_date");
          }}
          value={finStartDate}
          inputProps={{
            "data-markers": JSON.stringify({
              up: "config_accounts_cin_num",
              down: "config_accounts_fin_start_date",
              left: "config_accounts_retailer_short_name",
              right: "config_accounts_fin_end_date",
            }),
          }}
        />
      </Grid>
      <Grid item xs={3}>
        <DateInput
          id="config_accounts_fin_end_date"
          label={formLabels?.END_FIN_DATE?.displayName}
          ref={finEndDateRef}
          placeholder="DD/MM/YYYY"
          onChange={(e, value) => {
            setFinEndDate(value);
          }}
          onBlur={(e) => {
            props.handleFormChange("END_FIN_DATE", finEndDate, "ACCOUNTS");
          }}
          onFocus={() => {
            executeScroll(finEndDateRef);
            focusField("config_accounts_fin_end_date");
          }}
          value={finEndDate}
          inputProps={{
            "data-markers": JSON.stringify({
              up: "config_accounts_fssai_num",
              down: "config_accounts_fin_end_date",
              left: "config_accounts_fin_start_date",
              right: "config_accounts_email_details",
            }),
          }}
        />
      </Grid>

      <Grid item xs={12}>
        <div className={classes["accountconfigpanel-text-style"]}>
          Other Details
        </div>
      </Grid>
      <Grid item xs={3}>
        <TextInput
          id="config_accounts_email_details"
          name="emailDetails"
          ref={emailDetailsRef}
          label={formLabels?.EMAIL_ID?.displayName}
          value={emailId}
          onFocus={() => {
            executeScroll(emailDetailsRef);
            focusField("config_accounts_email_details");
          }}
          onChange={(e) => {
            setEmailId(e.target.value);
          }}
          onBlur={(e) => {
            props.handleFormChange("EMAIL_ID", e.target.value, "ACCOUNTS");
          }}
          inputProps={{
            "data-markers": JSON.stringify({
              up: "config_accounts_invoice_prefix",
              down: "config_accounts_email_details",
              left: "config_accounts_fin_end_date",
              right: "config_accounts_password",
            }),
          }}
        />
      </Grid>
      <Grid item xs={3}>
        <TextInput
          id="config_accounts_password"
          name="password"
          ref={passwordRef}
          label={formLabels?.PASSWORD?.displayName}
          type="password"
          value={password}
          onFocus={() => {
            executeScroll(passwordRef);
            focusField("config_accounts_password");
          }}
          onChange={(e) => {
            setPassword(e.target.value);
            props.handleFormChange("PASSWORD", e.target.value, "ACCOUNTS");
          }}
          inputProps={{
            "data-markers": JSON.stringify({
              up: "config_accounts_retailer_short_name",
              down: "config_accounts_password",
              left: "config_accounts_email_details",
              right: "config_accounts_password",
            }),
          }}
        />
      </Grid>
    </Grid>
  );
};

export default AccountConfigPanel;
